import { Branch } from '../lib/api';

const BRANCH_LABELS: Record<Branch, string> = {
  engineering: 'Engineering',
  data_science: 'Data Science',
  finance_economics: 'Finance & Econ',
};

interface BranchChipProps {
  branch: Branch | null;
  editable?: boolean;
  onChange?: (branch: Branch | null) => void;
}

export function BranchChip({ branch, editable = false, onChange }: BranchChipProps) {
  const label = branch ? BRANCH_LABELS[branch] : 'Unclassified';

  if (!editable) {
    return <span className={`badge${branch ? ' badge-blue' : ''}`}>{label}</span>;
  }

  return (
    <select
      className="select select-sm"
      value={branch ?? ''}
      onChange={e => {
        const val = e.target.value as Branch | '';
        onChange?.(val === '' ? null : val);
      }}
    >
      <option value="">Unclassified</option>
      <option value="engineering">Engineering</option>
      <option value="data_science">Data Science</option>
      <option value="finance_economics">Finance &amp; Econ</option>
    </select>
  );
}
